import React from 'react';

import { useIntl } from 'react-intl';

import { ApplicationsItemType } from '@marketplace/api';
import { Button } from '@marketplace/ui-elements';

import { ApplicationCard } from './application-card';
import { TListApplication } from '../app-gallery-page.types';
import {calculatesNumberOfApp} from '../helpers';

import './style.scss';

export default function ListApplications(props: TListApplication) {
  const { formatMessage } = useIntl();

  return (
    <>
      <div className="all-apps-list">
        {props.data.length > 0 &&
          props.data.map((data: ApplicationsItemType) => (
            <ApplicationCard {...data} key={data.id} />
          ))}
      </div>
      <div
        className="all-apps-button-block"
        hidden={props.hasNext===0}
      >
        <Button
          onClick={props.handleFetchAllApps}
          loading={props.loading}
          disabled={props.loading}
          variant="secondary"
        >
          {formatMessage({ id: 'app_gallety_load_apps' }, 
          {load_more_apps:  calculatesNumberOfApp(props.total, props.data.length)})}
        </Button>
      </div>
    </>
  );
}
